import React, { useState } from 'react';
import useTitle from '../../Hooks/useTitle';
import blogImage from '../../images/blog-image/blog1.webp';
import './Blog.css'
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import npm from '../../images/blog-image/npm.png'
import npm1 from '../../images/blog-image/npm1.jpeg'
import studyAbroad from '../../images/blog-image/study-abroad.jpg'
import visa from '../../images/blog-image/visa.jpg'
import program from '../../images/blog-image/study-program.jpg'
import code from '../../images/blog-image/code.jpeg'
import resume from '../../images/blog-image/resume.png'
import { useLanguage } from '../../context/LanguageContext';






const AllBlogsPage = () => {

    window.scrollTo(0, 0);
    useTitle('All Blogs | Fahim Faysal');

    //state for implementing search functionality
    const [search, setSearch] = useState('');


    const blogs = [
        {
            titleEnglish: '7 Most Popular Animation Libraries For React',
            titleBangla: 'রিঅ্যাক্ট এর জন্য 7টি সর্বাধিক জনপ্রিয় অ্যানিমেশন লাইব্রেরি',
            descriptionEnglish: 'For a React frontend developer, implementing animations on webpages is an integral part of your daily work...',
            descriptionBangla: 'রিঅ্যাক্ট ফ্রন্টএন্ড ডেভেলপারের জন্য, ওয়েবপেজে অ্যানিমেশন প্রয়োগ করা আপনার দৈনন্দিন কাজের একটি অবিচ্ছেদ্য অংশ...',
            dateEnglish: 'March 5, 2023',
            dateBangla: '৫ মার্চ, ২০২৩',
            link: '/blog1',
            pic: npm
        },

        {
            titleEnglish: 'Worst NPM Packages You Should Not Use',
            titleBangla: 'সবচেয়ে খারাপ NPM প্যাকেজ যা  ব্যবহার করা উচিত নয়',
            descriptionEnglish: 'For a React frontend developer, implementing animations on webpages is an integral part of your daily work...',
            descriptionBangla: 'নোড প্যাকেজ ম্যানেজার (এনপিএম) খুব দরকারী। এই ব্লগে আমরা কিছু হাস্যকর এনপিএম প্যাকেজ দেখব যেগুলি থাকা উচিত নয়...',
            dateEnglish: 'April 15, 2023',
            dateBangla: 'এপ্রিল ১৫, ২০২৩',
            link: '/blog2',
            pic: npm1
        },

        {
            titleEnglish: 'Why Study Abroad? Stories From International Students',
            titleBangla: 'কেন বিদেশে পড়াশুনা করবেন? আন্তর্জাতিক ছাত্রদের থেকে শুনুন',
            descriptionEnglish: 'You might find a degree course that isn not available in your home country. You might learn to live independently...',
            descriptionBangla: 'আপনি একটি ডিগ্রি খুঁজে পেতে পারেন যা আপনার দেশে উপলব্ধ নয়; আপনি স্বাধীনভাবে বাঁচতে এবং অন্যান্য সংস্কৃতি শিখতে পারেন...',
            dateEnglish: 'May 3, 2023',
            dateBangla: '৩ মে, ২০২৩',
            link: '/blog3',
            pic: studyAbroad
        },

        {
            titleEnglish: 'Everything You Need to Know about Student Visa',
            titleBangla: 'ছাত্র ভিসা সম্পর্কে আপনার যা জানা দরকার',
            descriptionEnglish: 'If you are on a journey abroad for the pursuit of further education, you will be facing several stops before you reach the final destination...',
            descriptionBangla: 'আপনি যদি শিক্ষা অর্জনের জন্য বিদেশ ভ্রমণে থাকেন তবে চূড়ান্ত গন্তব্যে পৌঁছানোর আগে আপনাকে কয়েকটি স্টপেজের মুখোমুখি...',
            dateEnglish: 'June 11, 2023',
            dateBangla: '১১ জুন, ২০২৩',
            link: '/blog4',
            pic: visa
        },

        {
            titleEnglish: "4 Reasons Why Year Gap In Study Isn't End of life?",
            titleBangla: "৪ টি কারণ কেন অধ্যয়নে বছরের ব্যবধান মানে জীবন শেষ নয়?",
            descriptionEnglish: "Say, you dream of taking some time off after you finish school to travel the world, meet people and decide your Bachelor’s degree...",
            descriptionBangla: "ধরুন আপনি স্কুল শেষ করার পরে বিশ্ব ভ্রমণ, লোকেদের সাথে দেখা এবং আপনার ব্যাচেলর সিদ্ধান্ত নেওয়ার জন্য সময় কাটানোর স্বপ্ন...",
            dateEnglish: 'July 7, 2023',
            dateBangla: '৭ জুলাই, ২০২৩',
            link: '/blog5',
            pic: program
        },

        {
            titleEnglish: "Tips For Writing Comments In Your Code",
            titleBangla: "আপনার কোডে ভালো মন্তব্য লেখার জন্য কিছু টিপস",
            descriptionEnglish: "When we write codes, we often need to comment. But do they really needed? I will describe some tips for writing good comments",
            descriptionBangla: "আমরা যখন কোড লিখি, তখন প্রায়ই মন্তব্য করতে হয়। কিন্তু তাদের কি সত্যিই প্রয়োজন? আমি ভাল মন্তব্য লেখার কিছু টিপস বর্ণনা করব",
            dateEnglish: 'July 23, 2023',
            dateBangla: '২৩ জুলাই , ২০২৩',
            link: '/blog6',
            pic: code
        },

        {
            titleEnglish: "How To Improve Your Resume In 9 Steps",
            titleBangla: "৯ টি ধাপে কীভাবে আপনার জীবনবৃত্তান্ত উন্নত করবেন ?",
            descriptionEnglish: "As you apply for jobs, it's important to create a resume for the position you want to pursue. Taking time to improve resume...",
            descriptionBangla: "আপনি চাকরির আবেদন করার সময় যে পদে যেতে চান তার জন্য মানসম্পন্ন জীবনবৃত্তান্ত তৈরি করা গুরুত্বপূর্ণ। জীবনবৃত্তান্ত উন্নত করতে সময়...",
            dateEnglish: 'August 10, 2023',
            dateBangla: '১০ আগস্ট, ২০২৩',
            link: '/blog7',
            pic: resume
        }
    ]



    const { language } = useLanguage();




    return (
        <div className=''>

            <div className='lg:mt-10 md:mt-20 mt-16  w-full h-screen bg-cover bg-no-repeat bg-fixed mb-10' style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, .55), rgba(0, 0, 0, .55)), url(${blogImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                maxWidth: '100%',
                height: '590px',
                backgroundPosition: 'center',
                overflow: 'hidden'
            }}>
                <div className=' content-div mx-auto text-center '>
                    <div className=''>
                        <h1 className='md:text-6xl text-[35px] font-bold text-white text-center font-serif uppercase'>Blog Page</h1>
                        <p className='text-center mt-4 text-white md:text-[22px] text-lg lg:mx-96 md:mx-8 mx-4'>Here are some of my blogs Related to React, JavaScript, npm and Study Abroad. I hope you will like it. Please read and give me feedbacks to improve myself</p>
                    </div>
                </div>
            </div>







            {
                language === 'english' ?
                    <h1 className='uppercase mt-12 mb-5  text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono'>All <span className='text-yellow-600 text-6xl'>Blogs</span>
                        <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                    </h1>
                    :

                    <h1 className='uppercase mt-12 mb-5  text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-mono'>সব <span className='text-yellow-600 text-6xl'>ব্লগ</span>
                        <div className=' lg:mt-1 md:mt-3 mt-3  text-center lg:w-[280px] md:w-[260px] sm:w-[240px] w-[240px] h-[70px]       wavy'></div>
                    </h1>
            }



            <div className='lg:px-56 md:px-0 px-0'>

                <form className='mb-2 lg:px-32 md:px-16 px-6'>
                    <input type="text" placeholder={language === 'english' ? 'Search Blogs' : 'ব্লগ অনুসন্ধান করুন'} className="input input-primary input-bordered w-full" onChange={(event) => setSearch(event.target.value)} />
                </form>


                <div className='mt-16 grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 lg:gap-x-12 md:gap-x-4 gap-x-3 gap-y-16 lg:px-10 md:px-2 sm:px-2 px-2 mx-auto' >

                    {
                        blogs.filter((blog) => {
                            return search.toLowerCase() === ''
                                ?
                                blog
                                :
                                blog.title.includes(search) || blog.title.toLowerCase().includes(search) || blog.title.toUpperCase().includes(search) || blog.date.includes(search) || blog.date.toLowerCase().includes(search) || blog.date.toUpperCase().includes(search)
                        })
                            .map((blog, index) =>
                                <>
                                    <div key={index}>

                                        <div className="rounded-md card  md:w-[355px] lg:w-[420px] sm:w-[340px] w-[340px] mx-auto bg-base-100 shadow-xl " >

                                            <figure><img className='w-full h-56 transition ease-out hover:ease-in delay-350 hover:scale-110 duration-300' src={blog.pic} alt="Blogs" /></figure>


                                            <div className="card-body">
                                                {
                                                    language === 'english' ?
                                                        <>
                                                            <h2 className="text-justify  -mt-4 card-title lg:text-[26px] md:text-[23px] text-[22px] tracking-wide text-white lg:leading-snug leading-tight">{blog.titleEnglish}</h2>
                                                            <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>{blog.descriptionEnglish}</p>
                                                            <p className='text-yellow-600 text-lg font-bold mt-2'>{blog.dateEnglish}</p>
                                                        </>
                                                        :
                                                        <>
                                                            <h2 className="text-justify -mt-4 card-title lg:text-[22px] md:text-[20px] text-[19px] tracking-wide text-white lg:leading-snug leading-tight">{blog.titleBangla}</h2>
                                                            <p className='lg:text-[17px] md:text-[15px] text-[14px] text-justify'>{blog.descriptionBangla}</p>
                                                            <p className='text-yellow-600 text-lg font-bold mt-2'>{blog.dateBangla}</p>
                                                        </>
                                                }

                                                <Link to={blog.link}>
                                                    <div className='bg-yellow-600 hover:bg-yellow-700 flex justify-center items-center rounded-md px-4 w-3/4 mt-4 mx-auto' title='View Details'>
                                                        {
                                                            language === 'english' ?
                                                                <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >Read Blog</button>
                                                                :
                                                                <button className='py-2 rounded-lg  text-white text-lg  border-0 mr-2' >ব্লগ পড়ুন</button>
                                                        }
                                                        <FiArrowRight className='text-2xl text-white'></FiArrowRight>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>

                                    </div>
                                </>
                            )
                    }
                </div>

            </div>


        </div>
    );
};

export default AllBlogsPage;